import i18n from '../i18n'

export enum PARTNER_COMPANY_FILTERS {
  SEARCH = 'SEARCH',
  STATUS = 'STATUS',
}

export enum PARTNER_COMPANY_STATUS {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export const getPartnershipStatusLabel = (
  key: PARTNER_COMPANY_STATUS,
): string | PARTNER_COMPANY_STATUS => {
  return (
    {
      [PARTNER_COMPANY_STATUS.ACTIVE]: i18n.global.t(
        'partnership.statusLabel.ACTIVE',
      ),
      [PARTNER_COMPANY_STATUS.INACTIVE]: i18n.global.t(
        'partnership.statusLabel.INACTIVE',
      ),
    }[key] || key
  )
}
